import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import useAppConfig from './useAppConfig';
import { SENSOR_DATA_EVENT, subscribeSocket } from '../services/socketService';

export { SENSOR_DATA_EVENT };

export default function useSensorSocket(onSensorData) {
  const { token: authToken } = useAuth();
  const { socketUrl } = useAppConfig();
  const callbackRef = useRef(onSensorData);
  callbackRef.current = onSensorData;

  useEffect(() => {
    const token = authToken || localStorage.getItem('shm_token');
    if (!token || !socketUrl) return undefined;

    return subscribeSocket(socketUrl, token, {
      onConnect: () => callbackRef.current?.({ type: 'connected' }),
      onDisconnect: () => callbackRef.current?.({ type: 'disconnected' }),
      onEvent: (event) => callbackRef.current?.(event),
    });
  }, [authToken, socketUrl]);
}
